// @flow strict
import type {NoteWriteback, NoteWritebackApi} from 'src/types/note-writeback';
import type {EmailApi} from 'src/types/email';


export const getDefaultNoteWritebackState = (): NoteWriteback => {
  return {
    nwbEntityType: null,
    nwbExternalEntityId: null,
    nwbNoteAction: null,
    nwbEnabled: false,
  };
};

export const parseNoteWriteback = (
  emailApiResponse: EmailApi,
): NoteWriteback => {
  const nwbEntityType = emailApiResponse.nwb_external_entity_type;
  const nwbExternalEntityId = emailApiResponse.nwb_external_entity_id;
  const nwbNoteAction = emailApiResponse.note_action;
  const nwbEnabled = emailApiResponse.nwb_enabled;
  return {
    nwbEntityType,
    nwbExternalEntityId,
    nwbNoteAction,
    nwbEnabled,
  };
};

export const normalizeNoteWriteback = (noteWriteback: {
  ...NoteWriteback,
  ...
}): NoteWritebackApi => {
  const {nwbEntityType, nwbExternalEntityId, nwbNoteAction, nwbEnabled} =
    noteWriteback;
  if (!nwbEnabled) {
    return {
      nwb_external_entity_type: null,
      nwb_external_entity_id: null,
      note_action: null,
      nwb_enabled: false,
    };
  }
  return {
    nwb_external_entity_type: nwbEntityType,
    nwb_external_entity_id: nwbExternalEntityId,
    note_action: nwbNoteAction,
    nwb_enabled: nwbEnabled,
  };
};
